import { render, staticRenderFns } from "./growthvalue.vue?vue&type=template&id=1c596210&scoped=true&"
import script from "./growthvalue.vue?vue&type=script&lang=js&"
export * from "./growthvalue.vue?vue&type=script&lang=js&"
import style0 from "./growthvalue.vue?vue&type=style&index=0&id=1c596210&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c596210",
  null
  
)

export default component.exports